export const fullHeight = { height: '100%' }
export const fullWidth = { width: '100%' }
export const flexbox = { display: 'flex' }
export const itemsx = { padding: 0, margin: '0',height:'40px',display:'flex',alignItems:'center' }
export const itemsxGrow = {...itemsx,flexGrow:1}
export const reportFlex = {...flexbox, paddingTop: '12px', paddingLeft: '22px', paddingRight: '22px',justifyContent:'start',flexWrap:'wrap',gap:'10px'}
export const novp = { paddingTop: 0, paddingBottom: 0 }